var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.86 4.242H19.278C18.3911 4.2412 17.5407 3.88853 16.9136 3.26139C16.2865 2.63425 15.9338 1.78391 15.933 0.897001C15.9338 0.778588 15.9111 0.661194 15.8661 0.551641C15.8212 0.442088 15.7549 0.342557 15.6712 0.258825C15.5874 0.175093 15.4879 0.108829 15.3784 0.0638821C15.2688 0.0189353 15.1514 -0.00379838 15.033 -0.00300097H5.14C3.77709 -0.000883925 2.47064 0.541603 1.5071 1.50551C0.543567 2.46942 0.00158683 3.77609 0 5.139L0 22.329C0.00211578 23.6916 0.544329 24.9977 1.50781 25.9612C2.47129 26.9247 3.77744 27.4669 5.14 27.469H26.86C28.2224 27.4669 29.5284 26.9248 30.4918 25.9615C31.4553 24.9983 31.9976 23.6924 32 22.33V9.376C31.9976 8.01407 31.4551 6.70869 30.4915 5.74622C29.5279 4.78376 28.2219 4.24279 26.86 4.242ZM30.2 22.323C30.1992 23.2099 29.8465 24.0603 29.2194 24.6874C28.5923 25.3145 27.7419 25.6672 26.855 25.668H5.14C4.25396 25.6659 3.40489 25.3126 2.77884 24.6856C2.15278 24.0586 1.80079 23.209 1.8 22.323V5.139C1.80106 4.25313 2.15316 3.40379 2.77919 2.77701C3.40522 2.15024 4.25413 1.79712 5.14 1.795H14.217C14.4294 2.98332 15.0526 4.05923 15.9776 4.83478C16.9027 5.61033 18.0708 6.0362 19.278 6.038H26.86C27.7459 6.04012 28.5948 6.39324 29.2208 7.02001C29.8468 7.64679 30.1989 8.49613 30.2 9.382V22.323Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7a6a6194d7a87ed212737def605cd3cb.svg";
export { ForwardRef as ReactComponent };